import { Component } from '@angular/core';
import { FeedbackPlatformConversation__FeedbackPlatformEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Conversations__FeedbackPlatform') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformconversation__feedbackplatform-form',
    templateUrl: './feedbackplatformconversation__feedbackplatform.form.component.html'
})
export class FeedbackPlatformConversation__FeedbackPlatformFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformConversation__FeedbackPlatformEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'conversationMessages', sectionName: 'Conversation Messages', isExpanded: false }
        ]);
    }
}

